const KEEP_ALIVE_GAIN = 0.0001;

function ignoreRejection() {
  return;
}

function isTouchBrowser() {
  return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}

export function startMoneykitConnectKeepAlive() {
  if (!isTouchBrowser()) return null;
  try {
    if (navigator.audioSession !== undefined) {
      navigator.audioSession.type = 'ambient';
    }
    const context = new AudioContext();
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    gain.gain.value = KEEP_ALIVE_GAIN;
    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.start();
    void context.resume().catch(ignoreRejection);
    context.onstatechange = function handleStateChange() {
      if (context.state !== 'running') void context.resume().catch(ignoreRejection);
    };
    return function stopMoneykitConnectKeepAlive() {
      context.onstatechange = null;
      void context.close().catch(ignoreRejection);
    };
  } catch {
    return null;
  }
}
